import React, { useState } from 'react';
import { Text } from 'tea-component';
import './index.scss';
import { getLocale } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import RealtimeUserRainbowModal from '../../pages/realtime/realtimeUsers/component/RealtimeUserRainbowModal';
import { IComponentType } from '../PageContainer/type';
import Render from '../PageContainer/Render';
import componentMap from '../../_config/compConfig';
import { getName } from '@home/utils/common';
export default function MetricsCardTitle(props: any) {
  const { config: propsConfig, switchSlot, ...componentData } = props;
  const { metricsInfo } = props?.data || {};
  const { titleEn, titleCn, isInflexion, isMetricsExplain = true, data, metricsWidth, modalTitleEn, modalTitleCn, style } = propsConfig;
  const isEn = getLocale() === 'en-US';
  const [isHover, setIsHover] = useState(false);
  const [portValue, setportValue] = useState(false);

  const switchData = {
    cardTitleSwitchVal: props?.data?.cardTitleSwitchVal
  };
  
  const renderSwitchSlot = () => {
    if (!switchSlot) return null;
    const { name, props: switchSlotProps, ...resetProps } = switchSlot || {};
    const SwitchSlotCom = componentMap?.[name];
    return SwitchSlotCom ? <SwitchSlotCom {...(resetProps || {})} {...(switchSlotProps || {})} switchData={switchData} changeData={props?.changeData} /> : null;
  };

  const switchSlotChildren = () => {
    const childrenList = switchSlot?.props?.componentMap?.[switchData?.cardTitleSwitchVal];

    return <>
      {
        childrenList?.map((item: IComponentType | undefined, index: any) => {
          return <Render
            // {...props}
            config={{ ...(item || {}), switchData }}
            key={item?.name + index}
            {...(componentData || {})}
          />;
        })
      }
    </>;
  };

  return (
    <div>
      <div className='realtime-port' style={style}>
        <Text className='port-text' >  {getName(isEn, titleEn, titleCn)}</Text>
        {isMetricsExplain && <i className='port-icon' onClick={() => { setportValue(true) }} onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }}>
          <SvgIcon className='port-icon' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} />
        </i>
        }
        {renderSwitchSlot?.()}
      </div>
      {switchSlotChildren?.()}
      <RealtimeUserRainbowModal
        metricsInfo={metricsInfo}
        modalTitle={getName(isEn, modalTitleEn, modalTitleCn)}
        data={data}
        metricsWidth={metricsWidth}
        isInflexion={isInflexion}
        visible={portValue}
        setVisible={setportValue}
      />
    </div>
  );
}